export default "__VITE_ASSET__DIg5oI93__"